// @flow
import Billboard from 'components/billboard/Billboard';
import { connect } from 'react-redux';

import { fetchArticlesStaticCategories } from 'actions/newsletterActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/billboard/Billboard';

export default connect(
  (state: StateType): StateProps => ({
    current_competition: state.settingsState.current_competition,
    status: state.newsletterState.status,
    title: state.settingsState.title,
    categoriesArticle: state.newsletterState.categoriesArticle,
    description: state.settingsState.description,
    keycloakData: state.userState.keycloakData,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticlesStaticCategories: () => dispatch(fetchArticlesStaticCategories())
  })
)(Billboard);
